/*
 * Module-level hand-off for "open Apply Brand with this saved template
 * already selected" — used when the Asset Library's Brand Templates tab
 * routes a pick into Apply Brand instead of doing anything itself (no
 * insert/extract logic lives in the Asset Library; it only navigates).
 *
 * Mirrors integrations/tools/deckorate/nav-bridge.ts's park-and-consume shape:
 * the Asset Library (task pane side) parks the choice and asks DeckorateModule
 * to switch to "apply-brand" (via requestDeckorateView); ApplyBrandPanel reads
 * and clears the park on its own mount, the same way DeckorateModule reads
 * nav-bridge's pending target on its mount.
 */

import type { SavedBrandTemplate } from "./brandTemplatesApi";
import type { MyBrandTemplate } from "./myBrandTemplatesStorage";

export type PendingSavedTemplateSelection =
  | { readonly kind: "org"; readonly template: SavedBrandTemplate }
  | { readonly kind: "local"; readonly template: MyBrandTemplate };

let pending: PendingSavedTemplateSelection | null = null;

/** Parks a selection made outside ApplyBrandPanel (the Asset Library). */
export function setPendingSavedTemplateSelection(selection: PendingSavedTemplateSelection): void {
  pending = selection;
}

/** Reads and clears the parked selection. Called once by ApplyBrandPanel on
 *  mount — clearing here stops a stale pick from hijacking a later, ordinary
 *  visit to Apply Brand. */
export function consumePendingSavedTemplateSelection(): PendingSavedTemplateSelection | null {
  const selection = pending;
  pending = null;
  return selection;
}
